import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const EmergencyLayout = lazy(() => import('@/pages/emergency/layout'));
const EmergencyDetailLayout = lazy(() => import('@/pages/emergency/[projectId]/detail-layout'));
const EmergencyClientLayout = lazy(() => import('@/pages/emergency/[projectId]/[clientId]/layout'));

// Lazy load emergency pages
const EmergencyPage = lazy(() => import('@/pages/emergency'));
const CreateEmergencyPage = lazy(() => import('@/pages/emergency/create'));
const EmergencyProjectMapPage = lazy(() => import('@/pages/emergency/[projectId]/map'));
const UpdateEmergencyProjectPage = lazy(() => import('@/pages/emergency/[projectId]/update'));
const EmergencyClientJobSpecsPage = lazy(() => import('@/pages/emergency/[projectId]/[clientId]/jobSpecifications'));
const CreateEmergencyClientJobSpecPage = lazy(
  () => import('@/pages/emergency/[projectId]/[clientId]/jobSpecifications/create')
);
const ViewEmergencyJobSpecPage = lazy(
  () => import('@/pages/emergency/[projectId]/[clientId]/jobSpecifications/[jobSpecificationId]/view')
);
const UpdateEmergencyJobSpecPage = lazy(
  () => import('@/pages/emergency/[projectId]/[clientId]/jobSpecifications/[jobSpecificationId]/update')
);

/**
 * Emergency routes
 * Handles emergency project management with nested layouts
 */
export const emergencyRoutes: RouteConfig = {
  path: '/emergency',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: EmergencyLayout,
      element: EmergencyPage,
    },
    {
      path: '/create',
      layout: EmergencyLayout,
      element: CreateEmergencyPage,
    },
    {
      path: '/:projectId',
      layout: EmergencyLayout,
      children: [
        {
          path: '/update',
          layout: EmergencyDetailLayout,
          element: UpdateEmergencyProjectPage,
        },
        {
          path: '/map',
          layout: EmergencyDetailLayout,
          element: EmergencyProjectMapPage,
        },
        {
          path: '/:clientId/jobSpecifications',
          layout: EmergencyDetailLayout,
          children: [
            {
              path: '',
              layout: EmergencyClientLayout,
              element: EmergencyClientJobSpecsPage,
            },
            {
              path: '/create',
              layout: EmergencyClientLayout,
              element: CreateEmergencyClientJobSpecPage,
            },
            {
              path: '/:jobSpecificationId/view',
              layout: EmergencyClientLayout,
              element: ViewEmergencyJobSpecPage,
            },
            {
              path: '/:jobSpecificationId/update',
              layout: EmergencyClientLayout,
              element: UpdateEmergencyJobSpecPage,
            },
          ],
        },
      ],
    },
  ],
};
